<template>
  <div>
    <link rel="stylesheet" :href="require('../../../assets/css/vue-select.css')">
    <fractelfone
      v-if = "device"
      :username = "device.id"
      :password = "device.password"
      :caller_id = "device.fonenumber"
      :caller_id_name = "device.name"
      :extension = "device.speed_dial"
      :hostname = "hostname"
      :websocket_url = "websocket_url"
      :unique_id = "device.unique_id"
      :fractelfone = "fractelfone"
      />
    <div class="phone-selector-container-mobile" v-else>
      <div class="col" style="margin-bottom: 2rem;" v-if="$whitelabel.showLogo()">
        <img :src="require('../../../assets/sqrql_logo.png')" width="160px" height="160px">
      </div>
      <div class="col-12" style="margin-top: 3rem; margin-bottom: 3rem; min-height: 222px;" v-if="processing">
        <b-spinner variant="teal" label="Spinning"></b-spinner>
      </div>
      <div class="col-12" v-else>
        <div class="col">
          <h4 v-if="devices.length > 0">{{ $t('selection.heading', { appName: $whitelabel.getAppName() }) }}</h4>
        </div>
        <div class="col-12" style="margin-top: 3rem; margin-bottom: 8rem;">
          <v-select
            v-if="devices.length > 0"
            v-model="deviceId"
            v-bind:options="devices"
            :clearable="false"
            @input="deviceSelect"
            />
          <b-alert variant="warning" :show="true" v-else>
            {{ $t('selection.disabled', { appName: $whitelabel.getAppName() }) }}
          </b-alert>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import vSelect from 'vue-select'
  import jwtDecode from 'jwt-decode'

  import parking from '../parking/Parking.vue'

  export default {
    name: 'FracTELfone',
    components: {
      'fractelfone': parking,
      'v-select': vSelect
    },
    mounted: async function () {
      var self = this

      if (self.windowWidth < 800) {
        window.resizeTo(420, 604)
      }

      const token = localStorage.getItem('fonestorm-token')
      const decoded = await jwtDecode(token)
      self.fractelfone = decoded.fractelfone || null

      try {
        self.processing = true
        var response = null
        if (localStorage.getItem('device')) {
          self.deviceId = localStorage.getItem('device')
          response = await axios.get(`${process.env.FONESTORM_API}/devices/${self.deviceId}/verto`, { headers: { token: localStorage.getItem('fonestorm-token') } })
          self.device = response.data.device
          self.hostname = self.$route.query.hostname || response.data.device.registrar || 'webrtc.fractel.net'
          self.websocket_url = self.$route.query.websocket_url ? self.$route.query.websocket_url : (response.data.device.registrar ? `wss://${response.data.device.registrar}:8082` : 'wss://webrtc.fractel.net:8082')
        } else if (self.fractelfone) {
          self.deviceId = self.fractelfone
          localStorage.setItem('device', self.fractelfone)
          response = await axios.get(`${process.env.FONESTORM_API}/devices/${self.deviceId}/verto`, { headers: { token: localStorage.getItem('fonestorm-token') } })
          self.device = response.data.device
          self.hostname = self.$route.query.hostname || response.data.device.registrar || 'webrtc.fractel.net'
          self.websocket_url = self.$route.query.websocket_url ? self.$route.query.websocket_url : (response.data.device.registrar ? `wss://${response.data.device.registrar}:8082` : 'wss://webrtc.fractel.net:8082')
        } else {
          response = await axios.get(`${process.env.FONESTORM_API}/devices`, { headers: { token: localStorage.getItem('fonestorm-token') } })
          response.data.devices.forEach((device) => {
            if (device.type === 'fractelfone' || device.type === 'webrtc device' || device.type === 'fractelfone test' || device.type === 'webrtc device test') {
              self.devices.push({
                label: device.name,
                code: device.id
              })
            }
          })
        }
        self.processing = false
      } catch (error) {
        self.processing = false
        self.$router.push({ name: 'Login' })
      }
    },
    data () {
      return {
        processing: false,
        deviceId: null,
        device: null,
        devices: [],
        hostname: null,
        websocket_url: null,
        windowWidth: window.innerWidth,
        fractelfone: null
      }
    },
    methods: {
      deviceSelect: async function () {
        var self = this
        try {
          self.processing = true
          if (self.deviceId) {
            var response = await axios.get(`${process.env.FONESTORM_API}/devices/${self.deviceId.code}/verto`, { headers: { token: localStorage.getItem('fonestorm-token') } })
            self.device = response.data.device
            self.hostname = self.$route.query.hostname || response.data.device.registrar || 'webrtc.fractel.net'
            self.websocket_url = self.$route.query.websocket_url ? self.$route.query.websocket_url : (response.data.device.registrar ? `wss://${response.data.device.registrar}:8082` : 'wss://webrtc.fractel.net:8082')
          }
          localStorage.setItem('device', self.deviceId.code)
          self.processing = false
        } catch (error) {
          self.processing = false
          if (error.response.status === 401) {
            self.$router.push({ name: 'Login' })
          }
        }
      }
    }
  }
</script>

<style scopped>
.phone-selector-container-mobile {
  background-color: white;
  padding: 20px !important;
  margin: 0 auto 0 auto !important;
  overflow: hidden;
  text-align: center !important;
}

.vs__dropdown-menu {
  max-height: 200px !important;
}

.vs__dropdown-option--highlight {
  background-color: #009AB1 !important;
}

.text-teal {
  color: #009AB1;
}
</style>
